import type { IxcFundingV1TransferKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FUNDING_TRANSFER_BASE_PATH = getResolvedPath('/funding/transfer');

export const getFundingTransferPath: EntityPathBuilder<IxcFundingV1TransferKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/funding', context.keys);
      }

      return FUNDING_TRANSFER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.transferId) {
        return undefined;
      }

      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/funding/transfer/$transferId', context.keys);
      }

      return getResolvedPath(`${FUNDING_TRANSFER_BASE_PATH}/$transferId`, context.keys);
    }
  }
};

export function getFundingTransferDetailPath(transferId: string | undefined, accountId?: string) {
  if (!transferId) {
    return undefined;
  }

  return getFundingTransferPath({ kind: 'detail', keys: { transferId, accountId } });
}
